import * as React from "react";
import { forwardRef } from "react";
const SvgIcPlus32 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.5 5.5H15V15H5.5L5.5 17.5H15V26.5H17.5V17.5L26.5 17.5V15L17.5 15V5.5Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcPlus32);
export { ForwardRef as ReactComponent };
